import { useListContext } from "react-admin";
import { Button, Toolbar, MenuItem, FormControl, Select, Typography } from "@mui/material";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";

const classes = {
    hellip: {
        padding: "1.2em",
    },
    select: {
        marginLeft: "15px",
        marginRight: "20px",
        marginTop: "1px",
    },
    toolbar: {
        justifyContent: "end",
    },
    text: {
        fontSize: 14,
    },
    page: {
        color: "#BEBEBE",
        fontSize: 14,
        marginLeft: "15px",
    },
    button: {
        marginLeft: "10px",
    },
};

const PrevPagination = () => {
    const { page, perPage, total, setPage, setPerPage } = useListContext();
    const nbPages = Math.ceil(total / perPage) || 1;

    // from pagination actions source code
    const range = () => {
        if (isNaN(page) || nbPages === 1) {
            return [];
        }
        const input = [];

        if (page > 1) {
            input.push(1);
        }
        if (page === 3) {
            input.push(2);
        }
        if (page > 3 && page < nbPages) {
            input.push(".");
        }
        if (page < nbPages - 1) {
            input.push(page + 1);
        }
        if (page < nbPages - 4) {
            input.push(".");
        }
        if (page < nbPages - 2) {
            input.push(nbPages - 1);
        }
        if (page === nbPages) {
            input.push(nbPages - 1);
        }
        if (page !== nbPages) {
            input.push(nbPages);
        }
        return input;
    };

    const goToPage = (event) => {
        if (page >= 1 && page <= nbPages) {
            setPage(parseInt(event.currentTarget.dataset.page));
        }
    };

    const renderPageNums = () => {
        return range().map((pageNum, index) =>
            pageNum === "." ? (
                <span key={`hyphen_${index}`} sx={classes.hellip}>
                    &hellip;
                </span>
            ) : (
                <Button key={pageNum} onClick={goToPage} data-page={pageNum}>
                    {pageNum}
                </Button>
            )
        );
    };

    const handleChangePerPage = (event) => {
        setPerPage(event.target.value);
    };

    const getNumRows = () => {
        if (page === nbPages) {
            return `${(page - 1) * perPage + 1}-${total} of ${total}`;
        } else {
            return `${(page - 1) * perPage + 1}-${page * perPage} of ${total}`;
        }
    };

    return (
        <Toolbar sx={classes.toolbar}>
            <Typography sx={classes.text}>Rows per page:</Typography>
            <FormControl>
                <Select
                    disableUnderline
                    sx={classes.select}
                    value={perPage}
                    label="Rows per page"
                    onChange={handleChangePerPage}
                >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                </Select>
            </FormControl>
            <Typography sx={classes.text}>{getNumRows()}</Typography>
            <Button
                sx={classes.button}
                disabled={page === 1}
                color="primary"
                key="prev"
                onClick={() => setPage(page - 1)}
            >
                <ChevronLeft />
                Prev
            </Button>
            {renderPageNums()}
            <Button disabled={page === nbPages} color="primary" key="next" onClick={() => setPage(page + 1)}>
                Next
                <ChevronRight />
            </Button>
            <Typography sx={classes.page}>{page}</Typography>
        </Toolbar>
    );
};

export default PrevPagination;
